// Screen 10's audit log (SPEC §8 Screen 10; J-073). Admin only: any other role reads why the page is
// empty, and the API refuses either way. `?resourceType&resourceId` opens it filtered to one resource
// (J-185: the Data page's Audit link); the id is opaque, such as `bundle:<uuid>`, never PHI.
// J-210: the screen is keyed by that filter, so the nav link (no search) opens it unfiltered instead of
// keeping the last resource, and "Show every resource" clears the URL too.
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";

import { AuditScreen } from "@/features/aco-admin/components/audit-screen";
import { usePermission } from "@/features/auth/use-permission";
import { auditSearchSchema } from "@/lib/route-search";

export const Route = createFileRoute("/_authenticated/admin/audit")({
  staticData: { screenName: "Audit log" },
  validateSearch: auditSearchSchema,
  component: AuditPage,
});

function AuditPage() {
  const canRead = usePermission({ acoAdmin: ["readAudit"] });
  const { resourceType, resourceId } = Route.useSearch();
  const navigate = useNavigate();
  if (!canRead)
    return (
      <AlertBanner variant="info" title="The audit log is for the admin role">
        An admin reviews who did what, and when.
      </AlertBanner>
    );
  return (
    <AuditScreen
      key={`${resourceType ?? ""}|${resourceId ?? ""}`}
      resource={resourceType === undefined ? undefined : { resourceType, resourceId }}
      onClearResource={() =>
        void navigate({
          to: "/admin/audit",
          search: (prev) => ({ ...prev, resourceType: undefined, resourceId: undefined }),
        })
      }
    />
  );
}
